import allWords from "./palavras.json"
import correctWords from "./palavrasCertas.json"

// Epoch: 2/1/2022 - January 2nd 2022
export const epoch = new Date(2022, 0, 2, 0, 0, 0, 0)

export { allWords, correctWords }
